module.exports = __webpack_public_path__ + "Lato-Italic.929eed9ae6ccf1089247.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Italic.eot
// module id = ../../../../../src/assets/fonts/Lato-Italic.eot
// module chunks = styles